;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import get from "lodash/get"
import find from "lodash/find"
import { GROUP_TYPES } from "../constants"
export default function getReadableGroupType({ group }) {
  const groupType = get(group, "type", null)

  if (groupType) {
    const findTextOfGroupType = find(GROUP_TYPES, (defaultGroupType) => {
      return defaultGroupType.value == groupType
    })

    return get(findTextOfGroupType, "text", "Unknown Group Type")
  }
  return "Unknown Group Type"
}
